import { computed, onMounted, reactive, ref } from "vue";
import type { Base64File } from "@/struct/FileTypes";
import type { TicketType } from "@/struct/FeedbackStruct";
import { useStore } from "@/store";

export function useFeedback() {
  const store = useStore();
  const isSuccessModal = ref<boolean>(false);
  const isErrorModal = ref<boolean>(false);
  const isAccepted = ref<boolean>(false);
  const isLoading = ref<boolean>(false);
  const isEmailError = ref<boolean>(false);
  const isValidEmail = ref<boolean>(false);
  const isValidPhone = ref<boolean>(false);
  const isValidType = ref<boolean>(false);
  const files = ref<Base64File[]>([]);
  const selectArr = computed(() => store.state.feedback.topics);

  const form = reactive<{
    theme: string;
    type: string;
    phone: string;
    email: string;
    comment: string;
  }>({
    theme: "",
    type: "",
    phone: "",
    email: "",
    comment: "",
  });

  const isEmptyPhoneEmailWithErrors = computed(() => {
    const themeEmpty = !form.theme;
    const phoneEmpty = !form.phone;
    const emailEmpty = !form.email;
    const typeEmpty = !form.type;
    const phoneError = form.phone.length < 18;
    const emailError = isEmailError.value;

    return (
      themeEmpty ||
      phoneEmpty ||
      emailEmpty ||
      typeEmpty ||
      phoneError ||
      emailError ||
      !isAccepted.value ||
      isLoading.value
    );
  });

  const validateEmail = (isValid: boolean): void => {
    isEmailError.value = !isValid;
    isValidEmail.value = !!(form.email && isValid);
  };

  const getTopicList = async () => {
    await store.dispatch("feedback/fetchTopics");
  };

  const resetForm = () => {
    form.comment = "";
    form.phone = "";
    form.type = "";
    form.email = "";
    form.theme = "";
    isAccepted.value = false;
    files.value = [];
  };

  const sendForm = async () => {
    isLoading.value = true;
    const formData: TicketType = {
      ticket_subject: form.theme,
      phone_model: form.type,
      customer_msisdn: form.phone,
      customer_email: form.email,
      ticket_body: form.comment,
      attachments: [],
    };
    if (files.value.length) {
      files.value.forEach((file) => {
        formData.attachments.push({
          Content: file.base64,
          ContentType: file.type,
          Filename: file.name,
        });
      });
    }
    await store
      .dispatch("feedback/sendTicket", formData)
      .then((res) => {
        console.log(res);
        isSuccessModal.value = true;
      })
      .catch((err) => {
        console.log(err);
        isErrorModal.value = true;
      })
      .finally(() => {
        isLoading.value = false;
        resetForm();
      });
  };

  const toggleModal = (state: boolean, name: "success" | "error") => {
    switch (name) {
      case "error":
        isErrorModal.value = state;
        break;
      case "success":
        isSuccessModal.value = state;
        break;
    }
  };

  onMounted(() => {
    getTopicList();
  });

  return {
    files,
    form,
    isAccepted,
    isEmailError,
    isEmptyPhoneEmailWithErrors,
    isErrorModal,
    isLoading,
    isSuccessModal,
    isValidPhone,
    isValidType,
    selectArr,
    sendForm,
    toggleModal,
    validateEmail,
  };
}
